import React, { HTMLAttributes } from 'react';
import clsx from 'clsx';

import { Icon, type IconType } from '@/stories/atoms/Icon/Icon';
import { Slot, type AsChildProps } from '@/stories/atoms/Slot/Slot';

import styles from './tag.module.css';


export type TagProps = React.PropsWithChildren & HTMLAttributes<HTMLSpanElement>& {
  /** Tag icon */
  icon?:  IconType,
  /** Tag label */
  label?: string,
  /** Style variantion */
  size?: 'small' | 'normal'
  /** Style variantion */
  variant?: 'primary' | 'secondary' | 'transparent' | 'ok' | 'nok' | 'ideeri-secondary',
  /** Set absolute position of the tag */
  position?: 'top-right' | 'bottom-right' | 'top-left' | 'bottom-left'
}

export type Props = AsChildProps<
  TagProps,
  HTMLAttributes<HTMLSpanElement>
>

/** Primary UI component for user interaction */
export const Tag = ({
  icon,
  label,
  variant,
  size,
  position,
  children,
  className,
  asChild,
  ...props
}: Props) => {
  const Component = asChild ? Slot : "span"

  return (
    <Component className={clsx(styles.base, styles.tag, variant && styles[variant], position && styles[position], size && styles[size], className)} {...props}>
      {icon && <Icon icon={icon} size={size === 'small' ? 'sm' :'lg'}/>}
      {label && <span className={styles.label}>{label}</span>}
      {children}
    </Component>
    )
};

export const DpeTag = ({
  label,
  size,
  position,
  children,
  className,
  icon,
  ...props
}: TagProps) => {
  return (
    <span className={clsx(styles.base, styles.dpe, position && styles[position], size && styles[size], className)} {...props}>
      <span className='sr-only'>DPE : </span>{label && <span className={styles.label}>{label}</span>}
      {children}
    </span>
  )
}
